import React from 'react'

const Orders = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Orders</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item">Sales</li>
            <li className="breadcrumb-item active">Orders</li>
          </ol>
        </nav>
      </div>
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">
                  <i className="bi bi-receipt me-2"></i>
                  Orders Management
                </h5>
                <p>View and manage customer orders. Track order status, process orders, and monitor order fulfillment.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Orders

